/**
 * @flow
 * @author: VaraKumar
 */

import React, { Component } from 'react'

import Images from '../../../../../themes/Images'

import {
  TextTestimonialContainerWrapper,
  TextTestimonialContainer,
  Heading,
  TestimonialText,
  TestimonialQuote,
  QuoteImage,
  HeadingWithoutH2
} from './styledComponents'

class TextTestimonial extends Component {
  static defaultProps = {
    textTestimonialHeading: '',
    textTestimonialContent: ''
  }
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.state = {
      containerHeight: undefined,
      headingHeight: undefined,
      onHovered: false
    }
  }

  setElementsHeights = (containerHeight, headingHeight) => {
    this.setState({
      containerHeight,
      headingHeight
    })
  }

  componentDidMount() {
    let containerHeight = this.containerRef.clientHeight
    let headingHeight = this.headingRef.clientHeight
    this.setElementsHeights(containerHeight, headingHeight)
  }

  mouseOnHover = () => {
    this.setState({ onHovered: true })
  }

  mouseOnLeave = () => {
    this.setState({ onHovered: false })
  }

  captureContainerRef = innerRef => {
    this.containerRef = innerRef
  }

  captureHeadingRef = innerRef => {
    this.headingRef = innerRef
  }

  render() {
    const { containerHeight, headingHeight, onHovered } = this.state
    const {
      textTestimonialHeading,
      textTestimonialHeadingWithoutH2,
      textTestimonialContent,
      isDark,
      excludeBottomMargin,
      fillHeight
    } = this.props
    return (
      <TextTestimonialContainerWrapper
        isDark={isDark}
        excludeBottomMargin={excludeBottomMargin}
        onMouseEnter={this.mouseOnHover}
        onMouseLeave={this.mouseOnLeave}
        fillHeight={fillHeight}
      >
        <TextTestimonialContainer
          isDark={isDark}
          onHovered={onHovered}
          outerElementHeight={containerHeight}
          innerRef={this.captureContainerRef}
        >
          {!textTestimonialHeadingWithoutH2 ? (
            <Heading
              as="h2"
              onHovered={onHovered}
              outerElementHeight={containerHeight}
              headingHeight={headingHeight}
              innerRef={this.captureHeadingRef}
            >
              {textTestimonialHeading}
            </Heading>
          ) : (
            <HeadingWithoutH2
              onHovered={onHovered}
              outerElementHeight={containerHeight}
              headingHeight={headingHeight}
              innerRef={this.captureHeadingRef}
            >
              {textTestimonialHeadingWithoutH2}
            </HeadingWithoutH2>
          )}
          <TestimonialText onHovered={onHovered}>
            {textTestimonialContent}
          </TestimonialText>
        </TextTestimonialContainer>
        <TestimonialQuote>
          <QuoteImage
            draggable={false}
            className="lazyload"
            dataSrc={Images.testimonials.galleryDesktopTestimonialQuote}
          />
        </TestimonialQuote>
      </TextTestimonialContainerWrapper>
    )
  }
}

export default TextTestimonial



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/TextTestimonial/index.js